window.PlummeI18n.register("en", {
  "manualPreview.reset": "Reset",
  "manualPreview.title": "Bookkeeping",
  "manualPreview.details": "Details",
  "manualPreview.summary": "Summary by account",
  "manualPreview.date": "Date",
  "manualPreview.account": "Account",
  "manualPreview.vat": "VAT code",
  "manualPreview.before": "Balance before",
  "manualPreview.amount": "Amount",
  "manualPreview.after": "Balance after",
  "manualPreview.debit": "Debit",
  "manualPreview.credit": "Credit",
  "manualPreview.net": "Net change",
  "manualPreview.warning.balances": "Balances are unavailable from the accounting records. Entries are shown without before and after balances.",
  "manualPreview.warning.editing": "For corrections, this shows the replacement entry. Before and after balances are not shown because the correction may also reverse an earlier voucher.",
  "manualPreview.warning.years": "The entries span multiple calendar years. Journal lines are shown, but before and after balances are not projected across years.",
  "manualPreview.warning.country": "The preview requires an accounting country or does not support the selected VAT treatment for that country."
});
